import { Link } from "react-router-dom";

const CONTENT_LINKS = [
  { label: "电视剧频道", to: "/category/tv" },
  { label: "电影频道", to: "/category/movie" },
  { label: "综艺频道", to: "/category/variety" },
  { label: "影视资讯", to: "/news" },
];

export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="mt-16 w-full bg-primary-950 text-primary-100">
      <div className="mx-auto max-w-[1280px] px-4 md:px-6 py-12 md:py-14">
        <div className="grid grid-cols-1 gap-10 sm:grid-cols-2 lg:grid-cols-4">
          <div className="lg:col-span-2">
            <Link to="/" className="flex items-center gap-2 cursor-pointer">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-accent-500 text-white">
                <i className="ri-movie-2-line text-xl"></i>
              </span>
              <span className="font-heading text-xl font-extrabold tracking-tight text-white">
                星空<span className="text-accent-400">传媒</span>
              </span>
            </Link>
            <p className="mt-4 max-w-md text-sm leading-relaxed text-primary-200">
              星空传媒致力于为影视爱好者提供优质的影视内容聚合服务。汇聚最新电视剧、电影与综艺资讯，支持分类筛选、内容检索与作品详情浏览，让每一次观看都从一次精准的发现开始。
            </p>
            <div className="mt-5 flex items-center gap-3">
              {["ri-wechat-line", "ri-weibo-line", "ri-movie-line", "ri-mail-line"].map((icon) => (
                <span
                  key={icon}
                  className="flex h-9 w-9 items-center justify-center rounded-full bg-primary-900 text-primary-100 transition-colors hover:bg-accent-500 hover:text-white"
                >
                  <i className={`${icon} text-lg`}></i>
                </span>
              ))}
            </div>
          </div>

          <div>
            <h4 className="font-heading text-sm font-bold text-white">
              <Link to="/" className="transition-colors hover:text-accent-400 cursor-pointer">
                内容导航
              </Link>
            </h4>
            <ul className="mt-4 space-y-3 text-sm">
              {CONTENT_LINKS.map((link) => (
                <li key={link.to}>
                  <Link
                    to={link.to}
                    className="text-primary-200 transition-colors hover:text-accent-400 cursor-pointer"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-bold text-white">
              <Link to="/news" className="transition-colors hover:text-accent-400 cursor-pointer">
                联系我们
              </Link>
            </h4>
            <ul className="mt-4 space-y-3 text-sm text-primary-200">
              <li className="flex items-center gap-2">
                <i className="ri-mail-line text-accent-400"></i>
                contact@xingkong-media.example.com
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-phone-line text-accent-400"></i>
                400-000-2025（工作日 9:00-18:00）
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-map-pin-line text-accent-400"></i>
                北京市朝阳区星空大厦 18 层
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 flex flex-col gap-3 border-t border-primary-900 pt-6 text-xs text-primary-300 sm:flex-row sm:items-center sm:justify-between">
          <p>© {year} 星空传媒 Xingkong Media. 本站影视内容与资讯均为演示数据，仅供展示使用。</p>
          <p className="flex items-center gap-4">
            <Link to="/news" className="transition-colors hover:text-accent-400 cursor-pointer">
              版权声明
            </Link>
            <Link to="/news" className="transition-colors hover:text-accent-400 cursor-pointer">
              用户协议
            </Link>
          </p>
        </div>
      </div>
    </footer>
  );
}